import "core-js/modules/es.array.includes.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "yz-terminal"
};
const _hoisted_2 = {
  key: 0,
  class: "yz-state err"
};
const _hoisted_3 = {
  class: "yz-topbar"
};
const _hoisted_4 = {
  class: "yz-topbar-left"
};
const _hoisted_5 = {
  class: "yz-date"
};
const _hoisted_6 = {
  class: "yz-topbar-right"
};
const _hoisted_7 = {
  class: "yz-tb-item"
};
const _hoisted_8 = {
  class: "c-up"
};
const _hoisted_9 = {
  class: "yz-tb-item"
};
const _hoisted_10 = {
  class: "c-down"
};
const _hoisted_11 = {
  class: "yz-tb-item"
};
const _hoisted_12 = {
  class: "c-warn"
};
const _hoisted_13 = {
  class: "yz-tb-item"
};
const _hoisted_14 = {
  class: "c-neutral"
};
const _hoisted_15 = {
  class: "yz-refresh-bar"
};
const _hoisted_16 = {
  class: "rf-live"
};
const _hoisted_17 = {
  key: 0,
  class: "rf-time"
};
const _hoisted_18 = {
  key: 1,
  class: "rf-loading"
};
const _hoisted_19 = {
  class: "rf-countdown"
};
const _hoisted_20 = {
  class: "yz-row yz-row-2"
};
const _hoisted_21 = {
  class: "yz-panel"
};
const _hoisted_22 = {
  class: "gauge-wrap"
};
const _hoisted_23 = {
  class: "gauge-svg",
  viewBox: "0 0 200 120"
};
const _hoisted_24 = ["stroke", "stroke-dasharray"];
const _hoisted_25 = ["x2", "y2", "stroke"];
const _hoisted_26 = ["fill"];
const _hoisted_27 = {
  class: "gauge-center"
};
const _hoisted_28 = {
  key: 0,
  class: "gauge-trend"
};
const _hoisted_29 = {
  class: "gs-desc"
};
const _hoisted_30 = {
  class: "metric-strip"
};
const _hoisted_31 = {
  class: "ms-label"
};
const _hoisted_32 = {
  class: "ms-unit"
};
const _hoisted_33 = {
  class: "advice-bar"
};
const _hoisted_34 = {
  class: "adv-tactic"
};
const _hoisted_35 = {
  key: 0,
  class: "adv-risk"
};
const _hoisted_36 = {
  key: 2,
  class: "battle-lines"
};
const _hoisted_37 = {
  key: 1,
  class: "panel-skeleton"
};
const _hoisted_38 = {
  class: "yz-panel"
};
const _hoisted_39 = {
  class: "yp-stats"
};
const _hoisted_40 = {
  class: "yp-stat"
};
const _hoisted_41 = {
  class: "yp-sub"
};
const _hoisted_42 = {
  class: "yp-stat"
};
const _hoisted_43 = {
  class: "yp-stat"
};
const _hoisted_44 = {
  class: "yp-val c-up"
};
const _hoisted_45 = {
  class: "yp-stat"
};
const _hoisted_46 = {
  class: "yp-grid"
};
const _hoisted_47 = {
  key: 0,
  class: "yp-cell-badge"
};
const _hoisted_48 = {
  key: 1,
  class: "yp-cell-badge yp-cell-badge-nuked"
};
const _hoisted_49 = {
  class: "yp-cell-name"
};
const _hoisted_50 = {
  key: 2,
  class: "yp-cell-sub"
};
const _hoisted_51 = {
  key: 1,
  class: "panel-skeleton"
};
const _hoisted_52 = {
  class: "yz-panel"
};
const _hoisted_53 = {
  class: "leader-zone"
};
const _hoisted_54 = {
  key: 0,
  class: "leader-main"
};
const _hoisted_55 = {
  class: "lm-crown"
};
const _hoisted_56 = {
  key: 0,
  class: "lm-live"
};
const _hoisted_57 = {
  class: "lm-name"
};
const _hoisted_58 = {
  class: "lm-tags"
};
const _hoisted_59 = {
  class: "lm-board"
};
const _hoisted_60 = {
  key: 0,
  class: "lm-theme"
};
const _hoisted_61 = {
  key: 0,
  class: "lm-price"
};
const _hoisted_62 = {
  key: 1,
  class: "lm-price lm-price-na"
};
const _hoisted_63 = {
  key: 2,
  class: "lm-realtime"
};
const _hoisted_64 = {
  key: 0,
  class: "lm-rt"
};
const _hoisted_65 = {
  key: 1,
  class: "lm-rt lm-rt-warn"
};
const _hoisted_66 = {
  key: 2,
  class: "lm-rt"
};
const _hoisted_67 = {
  key: 1,
  class: "leader-main leader-empty"
};
const _hoisted_68 = {
  class: "lm-name"
};
const _hoisted_69 = {
  class: "leader-trail"
};
const _hoisted_70 = {
  class: "lt-head"
};
const _hoisted_71 = {
  class: "lt-track"
};
const _hoisted_72 = {
  class: "lt-date"
};
const _hoisted_73 = {
  key: 0,
  class: "lt-rt-dot"
};
const _hoisted_74 = {
  class: "lt-stock"
};
const _hoisted_75 = {
  class: "yz-row yz-row-2"
};
const _hoisted_76 = {
  class: "yz-panel"
};
const _hoisted_77 = {
  class: "yz-panel-head"
};
const _hoisted_78 = ["title"];
const _hoisted_79 = {
  key: 0,
  class: "ladder-zone"
};
const _hoisted_80 = {
  class: "lr-num"
};
const _hoisted_81 = {
  class: "lr-stocks"
};
const _hoisted_82 = {
  class: "ls-name"
};
const _hoisted_83 = {
  key: 0,
  class: "ls-theme"
};
const _hoisted_84 = {
  key: 1,
  class: "ls-tags"
};
const _hoisted_85 = ["onMouseenter"];
const _hoisted_86 = {
  key: 1,
  class: "ls-tag"
};
const _hoisted_87 = {
  key: 2,
  class: "ls-tag"
};
const _hoisted_88 = {
  key: 3,
  class: "ls-tag ls-tag-warn"
};
const _hoisted_89 = {
  class: "lr-count"
};
const _hoisted_90 = {
  key: 1,
  class: "yz-empty"
};
const _hoisted_91 = {
  key: 2,
  class: "broken-strip"
};
const _hoisted_92 = {
  class: "bs-left"
};
const _hoisted_93 = {
  class: "bs-count c-warn"
};
const _hoisted_94 = {
  class: "bs-ratio"
};
const _hoisted_95 = {
  class: "c-warn"
};
const _hoisted_96 = {
  class: "bs-bar-track"
};
const _hoisted_97 = {
  class: "bs-hint"
};
const _hoisted_98 = {
  key: 3,
  class: "bl-grid"
};
const _hoisted_99 = {
  key: 0,
  class: "bl-cell-badge"
};
const _hoisted_100 = {
  class: "bl-cell-name"
};
const _hoisted_101 = {
  key: 1,
  class: "bl-cell-sub"
};
const _hoisted_102 = {
  class: "bl-cell-meta"
};
const _hoisted_103 = ["onMouseenter"];
const _hoisted_104 = {
  class: "bl-cell-bt"
};
const _hoisted_105 = {
  class: "yz-panel"
};
const _hoisted_106 = {
  class: "ld-head"
};
const _hoisted_107 = {
  class: "ld-count c-down"
};
const _hoisted_108 = {
  key: 0,
  class: "ld-grid"
};
const _hoisted_109 = {
  class: "ld-name"
};
const _hoisted_110 = {
  key: 0,
  class: "ld-theme"
};
const _hoisted_111 = {
  class: "ld-chg c-down"
};
const _hoisted_112 = {
  key: 1,
  class: "yz-empty"
};
const _hoisted_113 = {
  key: 2,
  class: "ld-collapse-warn"
};
const _hoisted_114 = {
  key: 3,
  class: "ld-hint"
};
const _hoisted_115 = {
  class: "yz-panel"
};
const _hoisted_116 = {
  key: 0,
  class: "sector-zone"
};
const _hoisted_117 = {
  class: "sec-date"
};
const _hoisted_118 = {
  class: "sec-cells"
};
const _hoisted_119 = {
  class: "sc-name"
};
const _hoisted_120 = {
  class: "sc-meta"
};
const _hoisted_121 = {
  key: 0,
  class: "sc-leader"
};
const _hoisted_122 = {
  class: "sc-life"
};
const _hoisted_123 = {
  key: 1,
  class: "yz-empty"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.errorMsg && !$data.rawCycle.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($data.errorMsg), 1)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString($options.latestDate), 1), _createElementVNode("span", {
    class: _normalizeClass(["yz-stage-badge", $data.cycleLoaded ? $options.stageClass : 'stage-loading'])
  }, _toDisplayString($data.cycleLoaded ? $options.stageLabel + '期' : '分析中'), 3), _createElementVNode("span", {
    class: _normalizeClass(["yz-ph-tip yz-topbar-tip", {
      open: $data.topTipOpen
    }]),
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $data.topTipOpen = !$data.topTipOpen, ["stop"]))
  }, [...(_cache[4] || (_cache[4] = [_createStaticVNode("<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-944e1e62><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-944e1e62></circle><path d=\"M12 16v-4\" data-v-944e1e62></path><path d=\"M12 8h.01\" data-v-944e1e62></path></svg><span class=\"tip-bubble tip-bubble-lg\" data-v-944e1e62><b data-v-944e1e62>页面定位</b><br data-v-944e1e62>面向短线/打板交易者的<i data-v-944e1e62>情绪周期看板</i>。核心方法论是&quot;顺势而为&quot;——冰点空仓等拐点，高潮满仓追涨，退潮果断撤退。回答三个问题：<i data-v-944e1e62>现在什么阶段？该用什么打法？风险在哪？</i><br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>情绪得分公式</b><br data-v-944e1e62>综合得分 = 高位晋级率×30% + 1进2成功率×25% + (1−炸板率)×100×25% + max(0, 100−跌停数×2)×20%<br data-v-944e1e62>四个因子分别衡量：<i data-v-944e1e62>空间</i>（高位能否晋级）、<i data-v-944e1e62>接力意愿</i>（1进2）、<i data-v-944e1e62>封板质量</i>（炸板率）、<i data-v-944e1e62>空头力量</i>（跌停数）<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>六状态策略矩阵</b><br data-v-944e1e62>· <i data-v-944e1e62>高潮 ≥70</i>：满仓追涨格局，聚焦3板+空间板，警惕盛极而衰<br data-v-944e1e62>· <i data-v-944e1e62>加速 50~69↑</i>：半仓做2板确认，最佳操作窗口<br data-v-944e1e62>· <i data-v-944e1e62>降温 50~69↓</i>：半仓但高位逐步兑现，只做确定性2板<br data-v-944e1e62>· <i data-v-944e1e62>回暖 30~49↑</i>：轻仓1板试错，冰点后修复期<br data-v-944e1e62>· <i data-v-944e1e62>退潮 30~49↓</i>：轻仓减仓防守，不接力不抄底<br data-v-944e1e62>· <i data-v-944e1e62>冰点 &lt;30</i>：空仓观望，不接力不抄底<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>七大板块怎么看</b><br data-v-944e1e62>· <i data-v-944e1e62>情绪仪表盘</i>：一眼看市场温度，关注拐点而非绝对值——冰点快速回升至50+是最佳进场信号；转折信号标签检测连续趋势（连升3日=回暖确认，骤降10分=退潮预警）<br data-v-944e1e62>· <i data-v-944e1e62>攻守建议条</i>：仪表盘底部直接给出仓位+打法，从看盘到决策——高潮满仓追涨，冰点空仓观望，被核数≥晋级数自动标&quot;核按钮横行&quot;<br data-v-944e1e62>· <i data-v-944e1e62>昨日涨停表现</i>：昨日涨停今日接力溢价，红盘比+平均溢价衡量打板次日回报，被核数多=退潮信号<br data-v-944e1e62>· <i data-v-944e1e62>龙头跟踪</i>：每日最高板是情绪天花板，龙头活着跟风有溢价，龙头倒下全场退潮；切换标签区分强切（高度不降）/弱切/腰斩<br data-v-944e1e62>· <i data-v-944e1e62>连板天梯</i>：金字塔结构（底宽顶窄）=健康，倒挂=异常；健康度标签自动判定金字塔/倒挂/断层；炸板率≥40%打板必亏；炸板名单展示谁在炸、炸前几板<br data-v-944e1e62>· <i data-v-944e1e62>板块轮动</i>：第2~3天确认→加速是最佳介入窗口，第4天+衰退预警只做龙头<br data-v-944e1e62>· <i data-v-944e1e62>跌停监控</i>：跌停数环比骤增比绝对值更危险，是退潮先行指标；同板块≥2只跌停自动标&quot;崩塌风险&quot;<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>数据架构</b><br data-v-944e1e62>三源并行独立刷新：周期分析(5min) + 行情快照(15s) + 涨跌停池(30s)，快数据秒开，慢数据骨架屏占位，互不阻塞<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>核心原则</b><br data-v-944e1e62>数据驱动决策，不预测涨跌——只呈现&quot;现在是什么状态&quot;，不给&quot;明天必涨&quot;的幻觉。信号是框架不是圣杯，需结合龙头高度与板块持续性综合判断</span>", 2)]))], 2)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_cache[5] || (_cache[5] = _createTextVNode("涨停 ", -1)), _createElementVNode("b", _hoisted_8, _toDisplayString($data.poolsLoaded ? $options.limitUpCount : '—'), 1)]), _cache[10] || (_cache[10] = _createElementVNode("span", {
    class: "yz-tb-sep"
  }, null, -1)), _createElementVNode("span", _hoisted_9, [_cache[6] || (_cache[6] = _createTextVNode("跌停 ", -1)), _createElementVNode("b", _hoisted_10, _toDisplayString($data.poolsLoaded ? $options.limitDownCount : '—'), 1)]), _cache[11] || (_cache[11] = _createElementVNode("span", {
    class: "yz-tb-sep"
  }, null, -1)), _createElementVNode("span", _hoisted_11, [_cache[7] || (_cache[7] = _createTextVNode("炸板 ", -1)), _createElementVNode("b", _hoisted_12, _toDisplayString($data.poolsLoaded || $data.cycleLoaded ? $options.brokenCount : '—'), 1)]), _cache[12] || (_cache[12] = _createElementVNode("span", {
    class: "yz-tb-sep"
  }, null, -1)), _createElementVNode("span", _hoisted_13, [_cache[8] || (_cache[8] = _createTextVNode("成交 ", -1)), _createElementVNode("b", _hoisted_14, _toDisplayString($options.turnoverText), 1)]), _cache[13] || (_cache[13] = _createElementVNode("span", {
    class: "yz-tb-sep"
  }, null, -1)), _createElementVNode("span", {
    class: "yz-tb-refresh",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.manualRefresh && $options.manualRefresh(...args)),
    title: "手动刷新"
  }, [(_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: _normalizeClass({
      spinning: $data.refreshing
    })
  }, [...(_cache[9] || (_cache[9] = [_createElementVNode("path", {
    d: "M21 12a9 9 0 1 1-2.64-6.36L21 8"
  }, null, -1), _createElementVNode("path", {
    d: "M21 3v5h-5"
  }, null, -1)]))], 2))])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, [_createElementVNode("i", {
    class: _normalizeClass(["rf-dot", {
      off: !$options.isMarketOpen
    }])
  }, null, 2), _createTextVNode(_toDisplayString($options.isMarketOpen ? '交易中 · 实时刷新' : '休市中'), 1)]), $data.lastUpdateTime ? (_openBlock(), _createElementBlock("span", _hoisted_17, "更新于 " + _toDisplayString($data.lastUpdateTime), 1)) : _createCommentVNode("", true), !$data.cycleLoaded ? (_openBlock(), _createElementBlock("span", _hoisted_18, [...(_cache[14] || (_cache[14] = [_createElementVNode("span", {
    class: "yz-spinner sm"
  }, null, -1), _createTextVNode("周期数据加载中…", -1)]))])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_19, _toDisplayString($options.countdownText), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_cache[19] || (_cache[19] = _createStaticVNode("<div class=\"yz-panel-head\" data-v-944e1e62><span class=\"yz-ph-title\" data-v-944e1e62>情绪周期</span><span class=\"yz-ph-tip\" data-v-944e1e62><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-944e1e62><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-944e1e62></circle><path d=\"M12 16v-4\" data-v-944e1e62></path><path d=\"M12 8h.01\" data-v-944e1e62></path></svg><span class=\"tip-bubble\" data-v-944e1e62><b data-v-944e1e62>计算规则</b><br data-v-944e1e62>综合得分 = 高位晋级率×30% + 1进2成功率×25% + (1−炸板率)×100×25% + max(0, 100−跌停数×2)×20%<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>六状态判读（结合趋势方向）</b><br data-v-944e1e62>≥70 <i data-v-944e1e62>高潮</i>：情绪亢奋，连板高度打开，但需警惕盛极而衰<br data-v-944e1e62>50~69↑ <i data-v-944e1e62>加速</i>：赚钱效应扩散，主流题材确认，最佳操作窗口<br data-v-944e1e62>50~69↓ <i data-v-944e1e62>降温</i>：从高潮回落，高位股开始分歧，逐步兑现<br data-v-944e1e62>30~49↑ <i data-v-944e1e62>回暖</i>：冰点后修复，试错成本低，轻仓布局先手<br data-v-944e1e62>30~49↓ <i data-v-944e1e62>退潮</i>：从加速跌落，亏钱效应扩散，减仓防守<br data-v-944e1e62>&lt;30 <i data-v-944e1e62>冰点</i>：亏钱效应主导，连板断层，空仓等待拐点<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>实战要点</b><br data-v-944e1e62>关注得分拐点而非绝对值：从冰点快速回升至50+是最佳进场信号；从高潮骤降10分以上是退潮预警。</span></span></div>", 1)), $data.cycleLoaded ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_22, [(_openBlock(), _createElementBlock("svg", _hoisted_23, [_cache[15] || (_cache[15] = _createElementVNode("path", {
    d: "M 20 110 A 80 80 0 0 1 180 110",
    fill: "none",
    stroke: "#e2e8f0",
    "stroke-width": "14",
    "stroke-linecap": "round"
  }, null, -1)), _createElementVNode("path", {
    d: "M 20 110 A 80 80 0 0 1 180 110",
    fill: "none",
    stroke: $options.gaugeColor,
    "stroke-width": "14",
    "stroke-linecap": "round",
    "stroke-dasharray": $options.gaugeDash,
    class: "gauge-arc"
  }, null, 8, _hoisted_24), _createElementVNode("line", {
    x1: 100,
    y1: 110,
    x2: $options.needleX,
    y2: $options.needleY,
    stroke: $options.gaugeColor,
    "stroke-width": "3",
    "stroke-linecap": "round",
    class: "gauge-needle"
  }, null, 8, _hoisted_25), _createElementVNode("circle", {
    cx: "100",
    cy: "110",
    r: "5",
    fill: $options.gaugeColor
  }, null, 8, _hoisted_26)])), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
    class: "gauge-num",
    style: _normalizeStyle({
      color: $options.gaugeColor
    })
  }, _toDisplayString($options.emotionScore), 5), _createElementVNode("div", {
    class: "gauge-stage",
    style: _normalizeStyle({
      color: $options.gaugeColor
    })
  }, _toDisplayString($options.stageLabel), 5)]), _cache[16] || (_cache[16] = _createElementVNode("div", {
    class: "gauge-scale"
  }, [_createElementVNode("span", null, "0 冰点"), _createElementVNode("span", null, "50 加速"), _createElementVNode("span", null, "100 高潮")], -1))]), $options.emotionTrend !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("span", {
    class: _normalizeClass($options.emotionTrend > 0 ? 'c-up' : 'c-down')
  }, _toDisplayString($options.emotionTrend > 0 ? '▲' : '▼') + " 较前日 " + _toDisplayString($options.emotionTrend > 0 ? '+' : '') + _toDisplayString($options.emotionTrend) + " 分 ", 3)])) : _createCommentVNode("", true), $options.emotionSignal ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["gauge-signal", $options.emotionSignal.cls])
  }, [_cache[17] || (_cache[17] = _createElementVNode("i", {
    class: "gs-dot"
  }, null, -1)), _createTextVNode(_toDisplayString($options.emotionSignal.label), 1), _createElementVNode("span", _hoisted_29, _toDisplayString($options.emotionSignal.desc), 1)], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.emotionMetrics, m => {
    return _openBlock(), _createElementBlock("div", {
      class: "ms-item",
      key: m.key
    }, [_createElementVNode("div", _hoisted_31, _toDisplayString(m.label), 1), _createElementVNode("div", {
      class: _normalizeClass(["ms-val", m.cls])
    }, [_createTextVNode(_toDisplayString(m.value), 1), _createElementVNode("span", _hoisted_32, _toDisplayString(m.unit), 1)], 2), m.diff != null ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["ms-diff", m.diff > 0 ? 'c-up' : 'c-down'])
    }, _toDisplayString(m.diff > 0 ? '+' : '') + _toDisplayString(m.diff), 3)) : _createCommentVNode("", true)]);
  }), 128))]), _createElementVNode("div", _hoisted_33, [_createElementVNode("span", {
    class: _normalizeClass(["adv-pos", $options.actionAdvice.positionCls])
  }, _toDisplayString($options.actionAdvice.position), 3), _createElementVNode("span", _hoisted_34, _toDisplayString($options.actionAdvice.tactic), 1), $options.actionAdvice.riskTag ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString($options.actionAdvice.riskTag), 1)) : _createCommentVNode("", true)]), $options.battleSignals.length ? (_openBlock(), _createElementBlock("div", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.battleSignals, (sig, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["bl-line", sig.cls]),
      key: i
    }, _toDisplayString(sig.label) + "·" + _toDisplayString(sig.desc), 3);
  }), 128))])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[18] || (_cache[18] = [_createStaticVNode("<div class=\"sk-gauge\" data-v-944e1e62></div><div class=\"sk-metrics\" data-v-944e1e62><div class=\"sk-bar w60\" data-v-944e1e62></div><div class=\"sk-bar w40\" data-v-944e1e62></div><div class=\"sk-bar w50\" data-v-944e1e62></div><div class=\"sk-bar w35\" data-v-944e1e62></div><div class=\"sk-bar w55\" data-v-944e1e62></div></div>", 2)]))]))]), _createElementVNode("div", _hoisted_38, [_cache[27] || (_cache[27] = _createStaticVNode("<div class=\"yz-panel-head\" data-v-944e1e62><span class=\"yz-ph-title\" data-v-944e1e62>昨日涨停今日表现</span><span class=\"yz-ph-tip\" data-v-944e1e62><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-944e1e62><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-944e1e62></circle><path d=\"M12 16v-4\" data-v-944e1e62></path><path d=\"M12 8h.01\" data-v-944e1e62></path></svg><span class=\"tip-bubble\" data-v-944e1e62><b data-v-944e1e62>接力溢价</b><br data-v-944e1e62>昨日涨停股今日的接力回报，衡量打板次日溢价：<br data-v-944e1e62>· <i data-v-944e1e62>红盘比</i>：今日上涨家数占比，≥60%接力环境友好<br data-v-944e1e62>· <i data-v-944e1e62>平均溢价</i>：全体算术平均涨幅，负值=昨日打板今日亏钱<br data-v-944e1e62>· <i data-v-944e1e62>连板晋级</i>：今日继续涨停的家数，越多情绪越强<br data-v-944e1e62>· <i data-v-944e1e62>被核</i>：跌幅超5%的家数，多=核按钮横行，严禁接力<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>实战要点</b><br data-v-944e1e62>红盘比+平均溢价同为正 → 接力可做；被核数≥连板晋级数 → 退潮信号，只卖不买。</span></span></div>", 1)), $options.yesterdayPerformance ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_cache[20] || (_cache[20] = _createElementVNode("span", {
    class: "yp-label"
  }, "红盘比", -1)), _createElementVNode("span", {
    class: _normalizeClass(["yp-val", $options.yesterdayPerformance.upRatio >= 60 ? 'c-up' : $options.yesterdayPerformance.upRatio >= 40 ? 'c-neutral' : 'c-down'])
  }, _toDisplayString($options.yesterdayPerformance.upRatio) + "%", 3), _createElementVNode("span", _hoisted_41, _toDisplayString($options.yesterdayPerformance.upCount) + "/" + _toDisplayString($options.yesterdayPerformance.total), 1)]), _createElementVNode("div", _hoisted_42, [_cache[21] || (_cache[21] = _createElementVNode("span", {
    class: "yp-label"
  }, "平均溢价", -1)), _createElementVNode("span", {
    class: _normalizeClass(["yp-val", $options.yesterdayPerformance.avgPremium >= 0 ? 'c-up' : 'c-down'])
  }, _toDisplayString($options.yesterdayPerformance.avgPremium >= 0 ? '+' : '') + _toDisplayString($options.yesterdayPerformance.avgPremium) + "%", 3)]), _createElementVNode("div", _hoisted_43, [_cache[22] || (_cache[22] = _createElementVNode("span", {
    class: "yp-label"
  }, "连板晋级", -1)), _createElementVNode("span", _hoisted_44, _toDisplayString($options.yesterdayPerformance.continuedCount), 1), _cache[23] || (_cache[23] = _createElementVNode("span", {
    class: "yp-sub"
  }, "只", -1))]), _createElementVNode("div", _hoisted_45, [_cache[24] || (_cache[24] = _createElementVNode("span", {
    class: "yp-label"
  }, "被核", -1)), _createElementVNode("span", {
    class: _normalizeClass(["yp-val", $options.yesterdayPerformance.nukedCount > 0 ? 'c-down' : 'c-neutral'])
  }, _toDisplayString($options.yesterdayPerformance.nukedCount), 3), _cache[25] || (_cache[25] = _createElementVNode("span", {
    class: "yp-sub"
  }, "只", -1))])]), _createElementVNode("div", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.yesterdaySorted, s => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["yp-cell", {
        'yp-cell-cont': s.continued,
        'yp-cell-nuked': s.nuked
      }]),
      key: s.name
    }, [s.level ? (_openBlock(), _createElementBlock("i", _hoisted_47, _toDisplayString(s.level), 1)) : s.nuked ? (_openBlock(), _createElementBlock("i", _hoisted_48, "核")) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_49, _toDisplayString(s.name), 1), s.theme ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(s.theme), 1)) : _createCommentVNode("", true), _createElementVNode("span", {
      class: _normalizeClass(["yp-cell-pct", s.pct >= 0 ? 'c-up' : 'c-down'])
    }, _toDisplayString(s.pct >= 0 ? '+' : '') + _toDisplayString(s.pct) + "%", 3)], 2);
  }), 128))])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_51, [_cache[26] || (_cache[26] = _createElementVNode("div", {
    class: "sk-bar w40",
    style: {
      "height": "28px",
      "margin": "0 auto 14px"
    }
  }, null, -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, n => {
    return _createElementVNode("div", {
      class: "sk-bar w90",
      key: n,
      style: {
        "height": "14px",
        "margin-bottom": "8px"
      }
    });
  }), 64))]))])]), _createElementVNode("div", _hoisted_52, [_cache[30] || (_cache[30] = _createStaticVNode("<div class=\"yz-panel-head\" data-v-944e1e62><span class=\"yz-ph-title\" data-v-944e1e62>龙头跟踪</span><span class=\"yz-ph-tip\" data-v-944e1e62><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-944e1e62><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-944e1e62></circle><path d=\"M12 16v-4\" data-v-944e1e62></path><path d=\"M12 8h.01\" data-v-944e1e62></path></svg><span class=\"tip-bubble\" data-v-944e1e62><b data-v-944e1e62>龙头定义</b><br data-v-944e1e62>取每日最高连板的首只股票为市场总龙头，代表当日赚钱效应的天花板。<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>实时指标</b><br data-v-944e1e62>· <i data-v-944e1e62>封板时间</i>：越早封板越强，开盘秒板最强，尾盘封板偏弱<br data-v-944e1e62>· <i data-v-944e1e62>炸N次</i>：盘中开板次数，炸过板的封板质量差，次日溢价低<br data-v-944e1e62>· <i data-v-944e1e62>封单%</i>：封单量/流通股比，越大封得越死，≥5%锁死不开<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>轨迹图判读</b><br data-v-944e1e62>柱高 = 当日龙头连板高度；<i data-v-944e1e62>红色柱</i> = 龙头切换日（换人）；高度持续攀升 = 情绪升温，高度骤降 = 退潮。<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>切换信号</b><br data-v-944e1e62>龙头切换有三种含义：<br data-v-944e1e62>· <i data-v-944e1e62>自然断板</i>：老龙头连板终结，新龙头接棒 → 若高度不降反升，是强切换，可追新龙<br data-v-944e1e62>· <i data-v-944e1e62>被动让位</i>：老龙头炸板，低位股卡位 → 弱切换，警惕退潮<br data-v-944e1e62>· <i data-v-944e1e62>高度腰斩</i>：切换同时高度大幅下降 → 情绪冰点信号，严控仓位<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>实战要点</b><br data-v-944e1e62>总龙头是风向标：龙头活着，跟风股就有溢价；龙头倒下，全场退潮。盯龙头比盯指数更有用。</span></span></div>", 1)), _createElementVNode("div", _hoisted_53, [$options.currentLeader ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_cache[28] || (_cache[28] = _createTextVNode("♛ 总龙头 ", -1)), $options.currentLeader.realtime ? (_openBlock(), _createElementBlock("i", _hoisted_56, "实时")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_57, _toDisplayString($options.currentLeader.name), 1), _createElementVNode("div", _hoisted_58, [_createElementVNode("span", _hoisted_59, _toDisplayString($options.currentLeader.board) + "连板", 1), $options.currentLeader.theme ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString($options.currentLeader.theme), 1)) : _createCommentVNode("", true)]), $options.leaderPrice ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("span", {
    class: _normalizeClass(["lm-px", $options.leaderPrice.change >= 0 ? 'c-up' : 'c-down'])
  }, _toDisplayString($options.leaderPrice.price), 3), _createElementVNode("span", {
    class: _normalizeClass(["lm-chg", $options.leaderPrice.change >= 0 ? 'c-up' : 'c-down'])
  }, _toDisplayString($options.leaderPrice.change >= 0 ? '+' : '') + _toDisplayString($options.leaderPrice.changePct) + "% ", 3)])) : (_openBlock(), _createElementBlock("div", _hoisted_62, "—")), $options.leaderRealtime ? (_openBlock(), _createElementBlock("div", _hoisted_63, [$options.leaderRealtime.lockTime ? (_openBlock(), _createElementBlock("span", _hoisted_64, "封板 " + _toDisplayString($options.leaderRealtime.lockTime), 1)) : _createCommentVNode("", true), $options.leaderRealtime.breakTimes > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_65, "炸" + _toDisplayString($options.leaderRealtime.breakTimes) + "次", 1)) : _createCommentVNode("", true), $options.leaderRealtime.lockRatio != null ? (_openBlock(), _createElementBlock("span", _hoisted_66, "封单 " + _toDisplayString($options.leaderRealtime.lockRatio) + "%", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_67, [_cache[29] || (_cache[29] = _createElementVNode("div", {
    class: "lm-crown"
  }, "♛ 总龙头", -1)), _createElementVNode("div", _hoisted_68, _toDisplayString($data.cycleLoaded ? '—' : '加载中…'), 1)])), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, _toDisplayString($data.cycleLoaded ? '近' + $options.leaderTrail.length + '日龙头轨迹' : '轨迹加载中…'), 1), _createElementVNode("div", _hoisted_71, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.leaderTrail, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["lt-node", {
        'lt-switch': item.switched,
        'lt-realtime': item.realtime
      }]),
      key: item.date
    }, [_createElementVNode("div", _hoisted_72, [_createTextVNode(_toDisplayString(item.date.slice(5)), 1), item.realtime ? (_openBlock(), _createElementBlock("i", _hoisted_73)) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "lt-pill",
      style: _normalizeStyle({
        height: Math.max(item.board * 7, 14) + 'px'
      })
    }, [_createElementVNode("span", null, _toDisplayString(item.board) + "b", 1)], 4), _createElementVNode("div", _hoisted_74, _toDisplayString(item.name), 1), item.switched ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["lt-tag", 'lt-sw-' + item.switchType])
    }, _toDisplayString(item.switchType === 'strong' ? '强切' : item.switchType === 'crash' ? '腰斩' : '切换'), 3)) : _createCommentVNode("", true)], 2);
  }), 128))])])])]), _createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_cache[31] || (_cache[31] = _createElementVNode("span", {
    class: "yz-ph-title"
  }, "连板天梯", -1)), $options.ladderHealth ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(["lh-badge", $options.ladderHealth.cls]),
    title: $options.ladderHealth.desc
  }, _toDisplayString($options.ladderHealth.label), 11, _hoisted_78)) : _createCommentVNode("", true), _cache[32] || (_cache[32] = _createStaticVNode("<span class=\"yz-ph-tip\" data-v-944e1e62><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-944e1e62><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-944e1e62></circle><path d=\"M12 16v-4\" data-v-944e1e62></path><path d=\"M12 8h.01\" data-v-944e1e62></path></svg><span class=\"tip-bubble\" data-v-944e1e62><b data-v-944e1e62>天梯结构</b><br data-v-944e1e62>按连板高度从高到低排列当日所有连板股，反映市场身位分布：<br data-v-944e1e62>· <i data-v-944e1e62>5板+</i> 空间板：决定市场天花板，打开则全场溢价<br data-v-944e1e62>· <i data-v-944e1e62>3~4板</i> 高位股：情绪温度计，晋级率高=强市<br data-v-944e1e62>· <i data-v-944e1e62>1~2板</i> 基底：数量决定广度，是明日晋级的蓄水池<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>炸板率阈值</b><br data-v-944e1e62>≥40% 极高：打板亏钱效应强，封板即被砸<br data-v-944e1e62>25~39% 偏高：注意封板质量，优选缩量板<br data-v-944e1e62>15~24% 正常：正常博弈区间<br data-v-944e1e62>&lt;15% 封板意愿强：可积极打板<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>实战要点</b><br data-v-944e1e62>天梯呈<i data-v-944e1e62>金字塔</i>（底宽顶窄）= 健康；出现<i data-v-944e1e62>倒挂</i>（高位比低位多）= 异常，警惕退潮。1进2数量骤减是天梯断裂的前兆。</span></span>", 1))]), $options.todayBoardLevels.length ? (_openBlock(), _createElementBlock("div", _hoisted_79, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.todayBoardLevels, level => {
    return _openBlock(), _createElementBlock("div", {
      class: "ladder-row",
      key: level.num
    }, [_createElementVNode("div", {
      class: _normalizeClass(["lr-badge", level.num >= 5 ? 'badge-king' : level.num >= 3 ? 'badge-high' : 'badge-norm'])
    }, [_createElementVNode("span", _hoisted_80, _toDisplayString(level.num), 1), _cache[33] || (_cache[33] = _createElementVNode("span", {
      class: "lr-txt"
    }, "板", -1))], 2), _createElementVNode("div", _hoisted_81, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level.stocks, s => {
      return _openBlock(), _createElementBlock("div", {
        class: "lr-stock",
        key: s.code
      }, [_createElementVNode("span", _hoisted_82, _toDisplayString(s.name), 1), s.theme ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(s.theme), 1)) : _createCommentVNode("", true), s.lockTime || s.timeline || s.lockRatio != null || s.breakTimes > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_84, [s.timeline && s.breakTimes > 0 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "mini-tl",
        onMouseenter: $event => $options.showMtTip($event, s.timeline.text),
        onMouseleave: _cache[2] || (_cache[2] = (...args) => $options.hideMtTip && $options.hideMtTip(...args))
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.timeline.dots, (d, i) => {
        return _openBlock(), _createElementBlock("i", {
          key: i,
          class: _normalizeClass(["mt-dot", d.s === 1 ? 'mt-lock' : d.s === 2 ? 'mt-break' : 'mt-omit'])
        }, null, 2);
      }), 128))], 40, _hoisted_85)) : s.lockTime ? (_openBlock(), _createElementBlock("i", _hoisted_86, _toDisplayString(s.lockTime), 1)) : _createCommentVNode("", true), s.lockRatio != null ? (_openBlock(), _createElementBlock("i", _hoisted_87, "封" + _toDisplayString(s.lockRatio) + "%", 1)) : _createCommentVNode("", true), s.breakTimes > 0 ? (_openBlock(), _createElementBlock("i", _hoisted_88, "炸" + _toDisplayString(s.breakTimes), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    }), 128))]), _createElementVNode("div", _hoisted_89, _toDisplayString(level.stocks.length) + "只", 1)]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString($data.cycleLoaded ? '今日暂无连板数据' : '连板数据加载中…'), 1)), $data.poolsLoaded || $data.cycleLoaded ? (_openBlock(), _createElementBlock("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_cache[35] || (_cache[35] = _createElementVNode("span", {
    class: "bs-label"
  }, "炸板", -1)), _createElementVNode("span", _hoisted_93, _toDisplayString($options.brokenCount), 1), _createElementVNode("span", _hoisted_94, [_cache[34] || (_cache[34] = _createTextVNode("炸板率 ", -1)), _createElementVNode("b", _hoisted_95, _toDisplayString($options.brokenRatio) + "%", 1)]), $options.brokenRatioDiff !== null ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(["bs-diff", $options.brokenRatioDiff > 0 ? 'c-warn' : 'c-up'])
  }, " 较5日均 " + _toDisplayString($options.brokenRatioDiff > 0 ? '+' : '') + _toDisplayString($options.brokenRatioDiff) + "% ", 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_96, [_createElementVNode("div", {
    class: "bs-bar-fill",
    style: _normalizeStyle({
      width: Math.min($options.brokenRatio, 100) + '%'
    })
  }, null, 4)]), _createElementVNode("span", _hoisted_97, _toDisplayString($options.brokenHint), 1)])) : _createCommentVNode("", true), $options.brokenList.length ? (_openBlock(), _createElementBlock("div", _hoisted_98, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.brokenList, s => {
    return _openBlock(), _createElementBlock("div", {
      class: "bl-cell",
      key: s.name
    }, [s.days > 1 ? (_openBlock(), _createElementBlock("i", _hoisted_99, _toDisplayString(s.days) + "板", 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_100, _toDisplayString(s.name), 1), s.theme ? (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(s.theme), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_102, [s.timeline ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "mini-tl",
      onMouseenter: $event => $options.showMtTip($event, s.timeline.text),
      onMouseleave: _cache[3] || (_cache[3] = (...args) => $options.hideMtTip && $options.hideMtTip(...args))
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.timeline.dots, (d, i) => {
      return _openBlock(), _createElementBlock("i", {
        key: i,
        class: _normalizeClass(["mt-dot", d.s === 1 ? 'mt-lock' : d.s === 2 ? 'mt-break' : 'mt-omit'])
      }, null, 2);
    }), 128))], 40, _hoisted_103)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_104, "炸" + _toDisplayString(s.breakTimes) + "次", 1)]), _createElementVNode("span", {
      class: _normalizeClass(["bl-cell-pct", s.pct >= 0 ? 'c-up' : 'c-down'])
    }, _toDisplayString(s.pct >= 0 ? '+' : '') + _toDisplayString(s.pct) + "%", 3)]);
  }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_105, [_cache[37] || (_cache[37] = _createStaticVNode("<div class=\"yz-panel-head\" data-v-944e1e62><span class=\"yz-ph-title\" data-v-944e1e62>跌停监控</span><span class=\"yz-ph-tip\" data-v-944e1e62><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-944e1e62><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-944e1e62></circle><path d=\"M12 16v-4\" data-v-944e1e62></path><path d=\"M12 8h.01\" data-v-944e1e62></path></svg><span class=\"tip-bubble\" data-v-944e1e62><b data-v-944e1e62>数据来源</b><br data-v-944e1e62>实时拉取选股宝跌停池，展示当日所有触及跌停的股票。<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>跌停数阈值</b><br data-v-944e1e62>≥30 <i data-v-944e1e62>跌停潮</i>：亏钱效应极强，全场核按钮，严禁接力<br data-v-944e1e62>15~29 <i data-v-944e1e62>空头强</i>：跌停扩散中，高位股风险大，减仓防守<br data-v-944e1e62>5~14 <i data-v-944e1e62>正常</i>：常规博弈区间，关注是否有核按钮苗头<br data-v-944e1e62>&lt;5 <i data-v-944e1e62>偏暖</i>：空头力量弱，环境友好，可积极操作<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>实战要点</b><br data-v-944e1e62>· 跌停数<i data-v-944e1e62>环比骤增</i>（如从5跳到20）比绝对值更危险，是退潮先行指标<br data-v-944e1e62>· 高位股出现在跌停池 = 龙头断板，情绪拐点确认<br data-v-944e1e62>· 跌停池清零 + 涨停数上升 = 冰点反转信号，可考虑进场</span></span></div>", 1)), _createElementVNode("div", _hoisted_106, [_cache[36] || (_cache[36] = _createElementVNode("span", {
    class: "ld-title"
  }, "今日跌停", -1)), _createElementVNode("span", _hoisted_107, _toDisplayString($options.limitDownCount), 1)]), $options.limitDownWithTheme.length ? (_openBlock(), _createElementBlock("div", _hoisted_108, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.limitDownWithTheme, s => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["ld-card", {
        'ld-collapse': s.theme && $options.limitDownCollapseThemes.includes(s.theme)
      }]),
      key: s.symbol
    }, [_createElementVNode("span", _hoisted_109, _toDisplayString(s.name), 1), s.theme ? (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(s.theme), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_111, _toDisplayString(s.pct.toFixed(2)) + "%", 1)], 2);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_112, "今日无跌停，空头力量弱")), $options.limitDownCollapseThemes.length ? (_openBlock(), _createElementBlock("div", _hoisted_113, " ⚠ 板块崩塌：" + _toDisplayString($options.limitDownCollapseThemes.join('、')), 1)) : _createCommentVNode("", true), $data.limitDownStocks.length ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString($options.limitDownHint), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_115, [_cache[39] || (_cache[39] = _createStaticVNode("<div class=\"yz-panel-head\" data-v-944e1e62><span class=\"yz-ph-title\" data-v-944e1e62>板块轮动</span><span class=\"yz-ph-tip\" data-v-944e1e62><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-944e1e62><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-944e1e62></circle><path d=\"M12 16v-4\" data-v-944e1e62></path><path d=\"M12 8h.01\" data-v-944e1e62></path></svg><span class=\"tip-bubble\" data-v-944e1e62><b data-v-944e1e62>数据来源</b><br data-v-944e1e62>统计每日涨停股所属题材，按题材内涨停家数排序取前5，并追踪连续出现天数。<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>生命周期四阶段</b><br data-v-944e1e62><i data-v-944e1e62>第1天 · 启动</i>：新题材首日发酵，涨停家数少，先手优势大但确定性低<br data-v-944e1e62><i data-v-944e1e62>第2天 · 确认</i>：次日仍有涨停 → 题材确认，可参与龙头<br data-v-944e1e62><i data-v-944e1e62>第3天 · 加速</i>：板块扩散，跟风股补涨，利润最厚但分歧也最大<br data-v-944e1e62><i data-v-944e1e62>第4天+ · 衰退预警</i>：持续过久，资金审美疲劳，追高极易被埋<br data-v-944e1e62><br data-v-944e1e62><b data-v-944e1e62>实战要点</b><br data-v-944e1e62>· 最佳介入是<i data-v-944e1e62>确认→加速</i>的过渡日（第2~3天）<br data-v-944e1e62>· 衰退预警期只做龙头、不做跟风<br data-v-944e1e62>· 多个板块同时进入衰退 → 空窗期，等待新题材启动</span></span></div>", 1)), $options.sectorRows.length ? (_openBlock(), _createElementBlock("div", _hoisted_116, [_cache[38] || (_cache[38] = _createStaticVNode("<div class=\"sec-legend\" data-v-944e1e62><span class=\"sl-item\" data-v-944e1e62><i class=\"sl-dot sl-gray\" data-v-944e1e62></i>启动</span><span class=\"sl-item\" data-v-944e1e62><i class=\"sl-dot sl-blue\" data-v-944e1e62></i>确认</span><span class=\"sl-item\" data-v-944e1e62><i class=\"sl-dot sl-orange\" data-v-944e1e62></i>加速</span><span class=\"sl-item\" data-v-944e1e62><i class=\"sl-dot sl-red\" data-v-944e1e62></i>衰退预警</span></div>", 1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sectorRows, row => {
    return _openBlock(), _createElementBlock("div", {
      class: "sec-row",
      key: row.date
    }, [_createElementVNode("span", _hoisted_117, _toDisplayString(row.date.slice(5)), 1), _createElementVNode("div", _hoisted_118, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.hots, h => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["sec-cell", $options.lifecycleClass(h.streak)]),
        key: h.name
      }, [_createElementVNode("span", _hoisted_119, _toDisplayString(h.name), 1), _createElementVNode("span", _hoisted_120, _toDisplayString(h.stockCount) + "家 · " + _toDisplayString(h.maxBoard) + "板", 1), h.leader ? (_openBlock(), _createElementBlock("span", _hoisted_121, "龙 " + _toDisplayString(h.leader), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_122, _toDisplayString($options.lifecycleLabel(h.streak)), 1)], 2);
    }), 128))])]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_123, _toDisplayString($data.cycleLoaded ? '暂无板块轮动数据' : '板块数据加载中…'), 1))])], 64)), _withDirectives(_createElementVNode("div", {
    class: "mt-float",
    style: _normalizeStyle({
      left: $data.mtFloat.x + 'px',
      top: $data.mtFloat.y + 'px'
    })
  }, _toDisplayString($data.mtFloat.text), 5), [[_vShow, $data.mtFloat.show]])]);
}